import type { UrlDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export const printCoverLetter = async (data: { id: string }) => {
  const response = await axios.get<UrlDto>(`/cover-letter/print/${data.id}`);
  return response.data;
};

export const usePrintCoverLetter = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: printCoverLetterFn,
  } = useMutation({
    mutationFn: printCoverLetter,
  });

  return { printCoverLetter: printCoverLetterFn, loading, error };
};
